export default __webpack_public_path__ + "media/images/main/notification_h-8d1ee2db8a3382db5eb2c6286bcefaa4.png";